

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { deleteAction } from '@/request'

@Component
export default class TableComponent extends Vue {
  private loading: boolean = false
  private currentPage: number = 1
  private pageSize: number = 10
  private total: number = 0
  private pageOption: any = {
    showSizeChanger: false,
     showTotal: (total:any) => `共 ${total} 条`,
     total:0,
     pageSize:10,
  }
  private tableData: any[] = []

  @Prop({ type: String, default: 'id' }) readonly rowKey!: string; // 表格行 key
  @Prop({ type: Boolean, default: true }) readonly isPage!: boolean; // 是否分页
  @Prop({ type: Boolean, default: false }) readonly isSelect!: boolean; // 是否带复选框
   @Prop({ type: String, default: 'checkbox' }) readonly selectType!: string; // 是否带复选框
  @Prop({ type: Function }) readonly apiFun: Function | undefined; //api  (若果传了apiFun，默认请求)
  @Prop({ type: Object }) readonly prohibit: object | any; //多选框禁用操作 prohibit:{ name:禁用的key名称,rule:禁用的规则 }
  @Prop({ type: Function }) readonly setParams: Function | undefined; //接口参数

  @Prop({ type: Function }) readonly pageChange: Function | undefined; // 页码改变的回调函数

  @Prop({ type: Array, default: true }) readonly columns!: Array<any> | []; // 表头
    @Prop({ type: String, default: '' }) readonly deleteBatch?: string | undefined; // 删除url
  @Prop({ type: Array, default:()=>[] }) selectedRowKeys!: Array<any> | []
  @Prop({type:Boolean, default:false}) showfooter!:boolean
  // private selectedRowKeys: any[] = []
  // private onChange (selectedRowKeys: any, selectedRows: any){
  //   this.selectedRowKeys = selectedRowKeys
  //     this.$emit('onSelect',selectedRows)
  // }
  private footer(a:any){
    return a
  }
   private rowSelection: any = {
    selectedRowKeys: this.selectedRowKeys,
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
      this.rowSelection.selectedRowKeys = selectedRowKeys
      this.$emit('onSelect',selectedRows)
    },
    onSelect:(record:any, selected:any, selectedRows:any, nativeEvent:any)=>{
      this.$emit('onSelectKey',record)
    },
    onSelectAll:(selected:any, selectedRows:any, changeRows:any)=>{
      this.$emit('onSelectAll',selected)
    },
    getCheckboxProps:(record:any) => ({
          props: {
            disabled: record[this.prohibit.name] === this.prohibit.rule[0]||record[this.prohibit.name] === this.prohibit.rule[1], // Column configuration not to be checked
            // name: record.name,
          },
        }),
    type: this.selectType  
  }
  
   // api获取数据
  private mounted() {
    // console.log(this.selectedRowKeys)
    this.getData()
  }
 private handleTableChange(pagination: any){
    this.pageSize = pagination.pageSize
    this.currentPage = pagination.current
    this.getData()
    this.pageOption.pageSize = this.pageSize
 }
  private getData() {
    if (this.apiFun) {
      this.loading = true
      const pagination = {
        current: this.currentPage,
        size: this.pageSize,
      }
      let query = this.setParams ? this.setParams(pagination) : {}
     if (this.isPage) {
        if (query['current'] === undefined) {
          query = {
            ...pagination,
            ...query,
          }
        }
      }
      this.apiFun(query)
        .then((res: any) => {
          this.loading = false
    
          if (this.isPage) {
            if(res.data.hasOwnProperty('records')){
               this.tableData = res.data.records
            } else {
              this.tableData = res.data
             
            }
            const pageOption = { ...this.pageOption }
            pageOption.current = query.current
            pageOption.total = res.data.total
            this.pageOption = pageOption
          } else {
            this.tableData = res.data
            // console.log(this.tableData)
          }
          this.rowSelection.selectedRowKeys = this.selectedRowKeys
          this.$emit('pageClick', this.tableData)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
  //刷新数据(使用ref外部调用)
  refresh(val: boolean) {
    this.rowSelection.selectedRowKeys = []
    if (this.apiFun) {
      if (val) {
        this.currentPage = 1
        this.getData()
      } else {
        this.getData()
      }
    }
  }
  private deleteRecrod(id: string) {
    const me = this
    this.$confirm({
      title: '确认删除',
      content: '是否删除选中数据?',
      onOk: function () {
        deleteAction(me.deleteBatch, { id: id }).then((res: any) => {
          if (res && res.status === 0) {
            me.$message.success('删除成功!')
            me.getData()
          } else {
            me.$message.warning(res.message)
          }
        })
      },
    })
  }
}
